const globalData = {};
const fetchingUri = {};
export { globalData, fetchingUri };
